import { render } from "./productDtails.vue?vue&type=template&id=b12503d2"
import script from "./productDtails.vue?vue&type=script&lang=js"
export * from "./productDtails.vue?vue&type=script&lang=js"

import "./productDtails.vue?vue&type=style&index=0&id=b12503d2&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__